module.exports = __webpack_public_path__ + "static/media/CARD_XCARD@3x.9e2bb6d6.png";